module.exports = __webpack_public_path__ + "img/map03.a23225a6.png";